/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Signer,
  utils,
  Contract,
  ContractFactory,
  Overrides,
  BigNumberish,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Market, MarketInterface } from "../Market";

const _abi = [
  {
    inputs: [
      {
        internalType: "address payable",
        name: "_controlCenter",
        type: "address",
      },
      {
        internalType: "address",
        name: "_trustedForwarder",
        type: "address",
      },
      {
        internalType: "string",
        name: "_uri",
        type: "string",
      },
      {
        internalType: "uint128",
        name: "_marketFeeBps",
        type: "uint128",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "seller",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "listingId",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "listingId",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "seller",
            type: "address",
          },
          {
            internalType: "address",
            name: "assetContract",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "tokenId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "quantity",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "currency",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "pricePerToken",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "saleStart",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "saleEnd",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "tokensPerBuyer",
            type: "uint256",
          },
          {
            internalType: "enum Market.TokenType",
            name: "tokenType",
            type: "uint8",
          },
        ],
        indexed: false,
        internalType: "struct Market.Listing",
        name: "listing",
        type: "tuple",
      },
    ],
    name: "ListingUpdate",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint128",
        name: "newFee",
        type: "uint128",
      },
    ],
    name: "MarketFeeUpdate",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "assetContract",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "seller",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "listingId",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "listingId",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "seller",
            type: "address",
          },
          {
            internalType: "address",
            name: "assetContract",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "tokenId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "quantity",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "currency",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "pricePerToken",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "saleStart",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "saleEnd",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "tokensPerBuyer",
            type: "uint256",
          },
          {
            internalType: "enum Market.TokenType",
            name: "tokenType",
            type: "uint8",
          },
        ],
        indexed: false,
        internalType: "struct Market.Listing",
        name: "listing",
        type: "tuple",
      },
    ],
    name: "NewListing",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "assetContract",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "seller",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "listingId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "buyer",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "quantity",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "listingId",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "seller",
            type: "address",
          },
          {
            internalType: "address",
            name: "assetContract",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "tokenId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "quantity",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "currency",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "pricePerToken",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "saleStart",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "saleEnd",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "tokensPerBuyer",
            type: "uint256",
          },
          {
            internalType: "enum Market.TokenType",
            name: "tokenType",
            type: "uint8",
          },
        ],
        indexed: false,
        internalType: "struct Market.Listing",
        name: "listing",
        type: "tuple",
      },
    ],
    name: "NewSale",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bool",
        name: "restricted",
        type: "bool",
      },
    ],
    name: "RestrictedListerRoleUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "LISTER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "PAUSER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "_contractURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_listingId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_quantity",
        type: "uint256",
      },
    ],
    name: "addToListing",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "boughtFromListing",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_listingId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_quantity",
        type: "uint256",
      },
    ],
    name: "buy",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "contractURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getAllListings",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "listingId",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "seller",
            type: "address",
          },
          {
            internalType: "address",
            name: "assetContract",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "tokenId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "quantity",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "currency",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "pricePerToken",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "saleStart",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "saleEnd",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "tokensPerBuyer",
            type: "uint256",
          },
          {
            internalType: "enum Market.TokenType",
            name: "tokenType",
            type: "uint8",
          },
        ],
        internalType: "struct Market.Listing[]",
        name: "allListings",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_listingId",
        type: "uint256",
      },
    ],
    name: "getListing",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "listingId",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "seller",
            type: "address",
          },
          {
            internalType: "address",
            name: "assetContract",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "tokenId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "quantity",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "currency",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "pricePerToken",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "saleStart",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "saleEnd",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "tokensPerBuyer",
            type: "uint256",
          },
          {
            internalType: "enum Market.TokenType",
            name: "tokenType",
            type: "uint8",
          },
        ],
        internalType: "struct Market.Listing",
        name: "listing",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_assetContract",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
    ],
    name: "getListingsByAsset",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "listingId",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "seller",
            type: "address",
          },
          {
            internalType: "address",
            name: "assetContract",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "tokenId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "quantity",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "currency",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "pricePerToken",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "saleStart",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "saleEnd",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "tokensPerBuyer",
            type: "uint256",
          },
          {
            internalType: "enum Market.TokenType",
            name: "tokenType",
            type: "uint8",
          },
        ],
        internalType: "struct Market.Listing[]",
        name: "tokenListings",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_assetContract",
        type: "address",
      },
    ],
    name: "getListingsByAssetContract",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "listingId",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "seller",
            type: "address",
          },
          {
            internalType: "address",
            name: "assetContract",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "tokenId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "quantity",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "currency",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "pricePerToken",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "saleStart",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "saleEnd",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "tokensPerBuyer",
            type: "uint256",
          },
          {
            internalType: "enum Market.TokenType",
            name: "tokenType",
            type: "uint8",
          },
        ],
        internalType: "struct Market.Listing[]",
        name: "tokenListings",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_seller",
        type: "address",
      },
    ],
    name: "getListingsBySeller",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "listingId",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "seller",
            type: "address",
          },
          {
            internalType: "address",
            name: "assetContract",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "tokenId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "quantity",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "currency",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "pricePerToken",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "saleStart",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "saleEnd",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "tokensPerBuyer",
            type: "uint256",
          },
          {
            internalType: "enum Market.TokenType",
            name: "tokenType",
            type: "uint8",
          },
        ],
        internalType: "struct Market.Listing[]",
        name: "sellerListings",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoleMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleMemberCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "forwarder",
        type: "address",
      },
    ],
    name: "isTrustedForwarder",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_assetContract",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_currency",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_pricePerToken",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_quantity",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_tokensPerBuyer",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_secondsUntilStart",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_secondsUntilEnd",
        type: "uint256",
      },
    ],
    name: "list",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "listings",
    outputs: [
      {
        internalType: "uint256",
        name: "listingId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "seller",
        type: "address",
      },
      {
        internalType: "address",
        name: "assetContract",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "quantity",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "currency",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "pricePerToken",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "saleStart",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "saleEnd",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "tokensPerBuyer",
        type: "uint256",
      },
      {
        internalType: "enum Market.TokenType",
        name: "tokenType",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "marketFeeBps",
    outputs: [
      {
        internalType: "uint128",
        name: "",
        type: "uint128",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes[]",
        name: "data",
        type: "bytes[]",
      },
    ],
    name: "multicall",
    outputs: [
      {
        internalType: "bytes[]",
        name: "results",
        type: "bytes[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC1155BatchReceived",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC1155Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC721Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "restrictedListerRoleOnly",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_URI",
        type: "string",
      },
    ],
    name: "setContractURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint128",
        name: "feeBps",
        type: "uint128",
      },
    ],
    name: "setMarketFeeBps",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "restricted",
        type: "bool",
      },
    ],
    name: "setRestrictedListerRoleOnly",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalListings",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_listingId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_quantity",
        type: "uint256",
      },
    ],
    name: "unlist",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_listingId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_pricePerToken",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_currency",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_tokensPerBuyer",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_secondsUntilStart",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_secondsUntilEnd",
        type: "uint256",
      },
    ],
    name: "updateListingParams",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type MarketConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: MarketConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Market__factory extends ContractFactory {
  constructor(...args: MarketConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(
    _controlCenter: string,
    _trustedForwarder: string,
    _uri: string,
    _marketFeeBps: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Market> {
    return super.deploy(
      _controlCenter,
      _trustedForwarder,
      _uri,
      _marketFeeBps,
      overrides || {}
    ) as Promise<Market>;
  }
  getDeployTransaction(
    _controlCenter: string,
    _trustedForwarder: string,
    _uri: string,
    _marketFeeBps: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _controlCenter,
      _trustedForwarder,
      _uri,
      _marketFeeBps,
      overrides || {}
    );
  }
  attach(address: string): Market {
    return super.attach(address) as Market;
  }
  connect(signer: Signer): Market__factory {
    return super.connect(signer) as Market__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): MarketInterface {
    return new utils.Interface(_abi) as MarketInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): Market {
    return new Contract(address, _abi, signerOrProvider) as Market;
  }
}
